import Table, { TableRow } from "../../../component/table";
import axios from "axios";
import React, { useState, useEffect } from "react";

const DocumentFiles = ({ openTab, activity_assignment_id }) => {
  const [allDocumentList, setAllDocumentList] = useState([]);
  const getUploadedFile = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/activityperformance/activity_assignment_id/files/${activity_assignment_id}`
      )
      .then((res) => {
        setAllDocumentList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (openTab === 4) {
      getUploadedFile();
    }
  }, [openTab]);

  return (
    <div
      id="tabAdded"
      className={openTab === 4 ? "block space-y-2 py-4" : "hidden"}
    >
      <div className="overflow-x-auto shadow-lg rounded">
        <Table
          heads={[
            { headName: "TO DO", isSort: false, value: "TO DO" },
            { headName: "FILENAME", isSort: false, value: "FILENAME" },
            { headName: "ACTION", isSort: false, value: "ACTION" },
          ]}
          tClass="table-auto w-full"
          hClass="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200"
          bClass="text-sm divide-y divide-slate-200"
          thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-center font-semibold"
        >
          {allDocumentList.map((item, i) => {
            const { name, file_name, file_path } = item;
            return (
              <TableRow
                key={i}
                row={{ name, file_name }}
                tdClass="px-2 py-3 whitespace-nowrap text-indigo-00 first:font-semibold text-center"
              >
                <td className="px-2 py-3 whitespace-nowrap text-center">
                  <a href={file_path} download={file_name} target="_blank">
                    <button className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-400] text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-4 h-4 fill-current shrink-0 mr-2 text-white"
                      >
                        <path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" />
                      </svg>
                      Download
                    </button>
                  </a>
                </td>
              </TableRow>
            );
          })}
        </Table>
      </div>
    </div>
  );
};

export default DocumentFiles;
